import React from 'react'

const Solitaires = () => {
  return (
    <div>Solitaires</div>
  )
}

export default Solitaires